import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getClassName } from 'utils/ui/classes';
import { camelCase } from 'lodash';
const iconBaseClass = 'mr-2 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150';
const CollapsibleMenu = ({ expandByDefault, title, children }) => {
    const [expanded, setExpanded] = useState(expandByDefault);
    function handleToggleExpand() {
        setExpanded(!expanded);
    }
    const iconClass = getClassName(iconBaseClass, {
        'text-gray-400': expanded,
        'rotate-90': expanded,
        'text-gray-600': !expanded,
    });
    return (React.createElement("div", { className: "space-y-1" },
        React.createElement("button", { "data-testid": `navCollapsible-${camelCase(title)}`, onClick: handleToggleExpand, className: "flex items-center w-full py-2 pr-2 text-sm font-medium text-gray-600 bg-white hover:bg-gray-50 hover:text-gray-900 group focus:outline-none focus:ring-2 focus:ring-green-cm" },
            React.createElement("svg", { className: iconClass, viewBox: "0 0 20 20", "aria-hidden": "true" },
                React.createElement("path", { d: "M6 6L14 10L6 14V6Z", fill: "currentColor" })),
            title),
        expanded && React.createElement("div", { className: "space-y-1" }, children)));
};
CollapsibleMenu.propTypes = {
    expandByDefault: PropTypes.bool,
};
CollapsibleMenu.defaultProps = {
    expandByDefault: true,
};
export default CollapsibleMenu;
